import { cn } from '../lib/utils.js';
import { useBranding } from './branding.jsx';

/**
 * Logo. Default: BLIMO-CI vector logo (assets/brand/*.svg, copied to apps/{admin,portal}/public/brand/ by
 * tools/brand/render-icons.cjs). With runtime branding (Einstellungen → Branding) the uploaded logo is used instead:
 * `logo_dark_url` in dark mode (fallback: light logo), `favicon_url` as "mark". Until GET /branding has answered the
 * bundled logo is shown (no empty box).
 * variant "full": logo with lettering, switches with the .dark class; "mark": symbol only.
 * @param {{ variant?: 'full'|'mark', className?: string, alt?: string }} props
 */
export function BrandLogo({ variant = 'full', className, alt }) {
  const branding = useBranding();
  const label = alt ?? branding.company_name ?? 'BLIMO Immobilienverwaltung';

  if (variant === 'mark') {
    if (branding.favicon_url) {
      return (
        <span className={cn('inline-flex h-6 shrink-0', className)} data-slot="brand-logo" data-custom="true">
          <img src={branding.favicon_url} alt={label} className="h-full w-auto select-none object-contain" draggable="false" />
        </span>
      );
    }
    return (
      <span className={cn('inline-flex h-6 shrink-0', className)} data-slot="brand-logo">
        <img src="/brand/mark.svg" alt={label} className="h-full w-auto select-none dark:hidden" draggable="false" />
        <img src="/brand/mark-dark.svg" alt="" aria-hidden="true" className="hidden h-full w-auto select-none dark:block" draggable="false" />
      </span>
    );
  }

  const light = branding.logo_light_url ?? null;
  const dark = branding.logo_dark_url ?? light;
  if (light || dark) {
    return (
      <span className={cn('inline-flex shrink-0', className)} data-slot="brand-logo" data-custom="true">
        <img src={light ?? dark} alt={label} className="h-full w-auto max-w-full select-none object-contain dark:hidden" draggable="false" />
        <img
          src={dark ?? light}
          alt=""
          aria-hidden="true"
          className="hidden h-full w-auto max-w-full select-none object-contain dark:block"
          draggable="false"
        />
      </span>
    );
  }

  return (
    <span className={cn('inline-flex shrink-0', className)} data-slot="brand-logo">
      <img src="/brand/logo.svg" alt={label} className="h-full w-auto select-none dark:hidden" draggable="false" />
      <img src="/brand/logo-dark.svg" alt="" aria-hidden="true" className="hidden h-full w-auto select-none dark:block" draggable="false" />
    </span>
  );
}
